import routes from './src/cellwise-quality-routes';
import store from './src/cellwise-quality-store';

export default {
  install(Vue, options) {
    const { router, store: rootStore } = options;

    // 1. Dynamically register the namespaced Vuex store
    if (!rootStore.hasModule('cellwiseQualityDashboard')) {
      rootStore.registerModule('cellwiseQualityDashboard', store);
    }

    // 2. Inject routes dynamically under the global '/d' route
    const dashboardRoute = router.options.routes.find((r) => r.path === '/d');
    if (dashboardRoute) {
      // Check if route already exists to prevent HMR infinite loops and duplicate warnings
      const exists = dashboardRoute.children.some((child) => child.path === 'cellwise-quality-dashboard');
      if (!exists) {
        dashboardRoute.children.push(...routes);
        // Add the updated parent route back into the router instance
        router.addRoutes([dashboardRoute]);
      }
    }
  },
};
